"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CollapsibleToggleHeader = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _colors = require("HubStyleTokens/colors");

var _classnames = _interopRequireDefault(require("classnames"));

var _generalStore = require("general-store");

var _UserSettingsStore = _interopRequireDefault(require("crm_data/settings/UserSettingsStore"));

var _UserSettingsKeys = _interopRequireWildcard(require("crm_data/settings/UserSettingsKeys"));

var _UserSettingsActions = require("crm_data/settings/UserSettingsActions");

var _loggers = require("customer-data-tracking/loggers");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  border-bottom: 1px solid ", ";\n  opacity: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BASE_CLASSNAME = 'profile-3-col-sidebar';

var Wrapper = _styledComponents.default.div.withConfig({
  displayName: "CollapsibleToggleHeader__Wrapper",
  componentId: "sc-1prlbf6-0"
})(_templateObject(), _colors.BATTLESHIP, function (_ref) {
  var isRightSidebarCollapsed = _ref.isRightSidebarCollapsed;
  return isRightSidebarCollapsed === undefined ? 0 : 1;
});

var CollapsibleToggleHeader =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(CollapsibleToggleHeader, _PureComponent);

  function CollapsibleToggleHeader(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CollapsibleToggleHeader);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CollapsibleToggleHeader).call(this, props));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CollapsibleToggleHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isRightSidebarCollapsed) {
        _loggers.CrmLogger.log('sidebarInteraction', {
          action: 'Sidebar interaction',
          subAction: 'Collapsed on load'
        });
      }
    }
  }, {
    key: "handleToggleCollapseSidebar",
    value: function handleToggleCollapseSidebar() {
      var isRightSidebarCollapsed = this.props.isRightSidebarCollapsed;
      var subAction = (!isRightSidebarCollapsed ? 'Collapse' : 'Expand') + " sidebar";

      _loggers.CrmLogger.log('sidebarInteraction', {
        action: 'Sidebar interaction',
        subAction: subAction
      });

      (0, _UserSettingsActions.saveUserSetting)(_UserSettingsKeys.default.HAS_COLLAPSED_RIGHT_SIDEBAR, !isRightSidebarCollapsed);
    }
  }, {
    key: "renderCollapseToggle",
    value: function renderCollapseToggle() {
      return _react.default.createElement(_UIIcon.default, {
        color: _colors.CALYPSO,
        name: "last",
        className: (0, _classnames.default)((0, _defineProperty2.default)({}, BASE_CLASSNAME + "--icon-collapsed", this.props.isRightSidebarCollapsed)),
        size: 20
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement(Wrapper, {
        isRightSidebarCollapsed: this.props.isRightSidebarCollapsed,
        onClick: this.handleToggleCollapseSidebar,
        className: "width-100 p-all-3 pointer " + BASE_CLASSNAME + "--header",
        "data-unit-test": "profile-collapsible-header"
      }, this.renderCollapseToggle());
    }
  }]);
  return CollapsibleToggleHeader;
}(_PureComponent2.default);

exports.CollapsibleToggleHeader = CollapsibleToggleHeader;
var dependency = {
  isRightSidebarCollapsed: {
    stores: [_UserSettingsStore.default],
    deref: function deref() {
      return _UserSettingsStore.default.get(_UserSettingsKeys.HAS_COLLAPSED_RIGHT_SIDEBAR);
    }
  }
};
CollapsibleToggleHeader.propTypes = {
  isRightSidebarCollapsed: _propTypes.default.bool
};

var _default = (0, _generalStore.connect)(dependency)(CollapsibleToggleHeader);

exports.default = _default;